import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreLabel?: string;
  moreLink?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreLabel,
  moreLink,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div className="min-w-0">
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.18em] text-accent-600">
            <span className="inline-block h-[2px] w-5 bg-accent-500" />
            {eyebrow}
          </p>
        )}
        <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{description}</p>
        )}
      </div>
      {moreLabel && moreLink && (
        <Link
          to={moreLink}
          className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-line text-base" />
        </Link>
      )}
    </div>
  );
}